import React, { ReactNode } from 'react'
import classnames from 'classnames/bind'
import Link from 'next/link'

// Components
import Icon from '@/assets/icons'

// Libs
import useI18n from '@/hooks/useI18n'
import { handleGtmSocialChannel } from '@/methods/handleGtmEvent'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'
import { GtmSocialChannelChannel, GTM_LOCATION } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

interface ISocialMediaLink {
  icon: ReactNode
  url: string
  onClick?: () => void
  channel: GtmSocialChannelChannel
}

const FollowUs = () => {
  const { isOverseaUser } = useI18n()

  const links: ISocialMediaLink[] = [
    {
      icon: <Icon.Facebook />,
      url: 'https://www.facebook.com/tutorabcshop',
      channel: GtmSocialChannelChannel.FACEBOOK,
    },
    {
      icon: <Icon.MenuLine />,
      url: isOverseaUser ? EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER_HK : EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER,
      channel: GtmSocialChannelChannel.LINE,
    },
    {
      icon: <Icon.Instagram />,
      url: 'https://instagram.com/tutorabcshop',
      channel: GtmSocialChannelChannel.INSTAGRAM,
    },
  ]

  return (
    <div className={cx('follow-us')}>
      {links.map((link) => (
        <Link
          href={link.url}
          key={link.url}
          target='_blank'
          onClick={() => {
            handleGtmSocialChannel({ socialChannel: link.channel, location: GTM_LOCATION.FOOTER })
          }}
        >
          {link.icon}
        </Link>
      ))}
    </div>
  )
}

export default FollowUs
